const { Container } = require("components/CustomDatePicker/components/InputDate/styles")
const { default: TimerIcon } = require("icons/TimerIcon")

const InputTime = ({
    value,
    onClick
}) => {
    return(
        <Container onClick={onClick}>
            <span>{value}</span>
            <TimerIcon/>
        </Container>
    )
}

export default InputTime;